// Copyright (c) Docugami, Inc. All rights reserved.

import { IResources } from "sdv/Resources";
import { CursorComponent } from "sdv/components/CursorComponent";
import { InteractableComponent, InteractionType } from "sdv/components/InteractableComponent";
import { ComponentId } from "sdv/engine/Component";
import { Entity, IEntityManager } from "sdv/engine/Entity";
import { ActionId } from "sdv/input/Actions";
import { IInput } from "sdv/input/InputController";
import { pointInBox } from "store/shared_types";
import { ISystem, Queries } from "../engine/Engine";

export class InteractableClickSystem implements ISystem {
    get updateEnabled() { return true }

    input!: IInput;
    entities!: IEntityManager;
    resources!: IResources;
    queries: Queries = {
        cursor: { types: [ComponentId.Cursor] },
        interactableHit: { types: [ComponentId.Interactable, ComponentId.CursorHit] }
    }

    private _pressedInteractable: Entity | null = null;

    update() {
        this.handleSelectInput();
    }

    private handleSelectInput() {
        // Handle clickable interactables
        const interactable = this.queries.interactableHit.query!.entities[0];
        const interactableHit = interactable?.getComponent<InteractableComponent>(ComponentId.Interactable);
        if (interactableHit?.interactionType !== InteractionType.Click) {
            return;
        }

        const selectState = this.input.getButton(ActionId.Select);
        const cursor = this.queries.cursor.query!.single()?.getComponent<CursorComponent>(ComponentId.Cursor)!.point;
        const isTargetInteractable = () => !!cursor && pointInBox(cursor.x, cursor.y, interactableHit.hitBox);

        if (selectState.isDown && !selectState.handled) {
            this._pressedInteractable = isTargetInteractable() ? interactable : null;
            if (!!this._pressedInteractable) {
                selectState.handle();
            }
        }
        else if (selectState.isUp) {
            if (interactable === this._pressedInteractable && isTargetInteractable()) {
                selectState.handle();
                interactableHit.onClick?.();
            }

            this._pressedInteractable = null;
        }
        else if (!selectState.isPressed) {
            this._pressedInteractable = null;
        }
    }
}